import {field} from '../field'
import {mergeConfig} from '../../configStore'
import type {StringField, FieldReturn} from '../../types'

export const string = (props?: StringField, mergeProps?: Partial<StringField>): FieldReturn =>
  field('string', mergeConfig('string', props, mergeProps))
